<template>
  <v-flex>
    <modal>
      <template v-slot:headline>
        {{ $t('web_ie_modal_title') }}
      </template>
      <p>{{ $t('web_ie_modal_message') }}</p>
    </modal>
  </v-flex>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
const { mapGetters, mapActions } = createNamespacedHelpers('commonState');

import Modal from '@/components/ui/Modal';

export default {
  components: {
    Modal
  }
};
</script>
